// extracted by mini-css-extract-plugin
export default {"JuryBadge":"JuryBadge_JuryBadge__I272C"};